import { render } from "./UserReview.vue?vue&type=template&id=68550c40&scoped=true"
import script from "./UserReview.vue?vue&type=script&lang=js"
export * from "./UserReview.vue?vue&type=script&lang=js"

import "./UserReview.vue?vue&type=style&index=0&id=68550c40&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68550c40"]])

export default __exports__